import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { getErrorMessage } from '@/services';
import { insurerPluginsService, type SwitchWrite } from '@/services/insurerPlugins';

export function useInsurerPlugins() {
  return useQuery({
    queryKey: ['admin-insurer-plugins'],
    queryFn: () => insurerPluginsService.list(),
  });
}

export function useSetInsurerSwitch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SwitchWrite) => insurerPluginsService.setSwitch(input),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['admin-insurer-plugins'] });
      queryClient.invalidateQueries({ queryKey: ['live-insurers'] });
      // Report the server's EFFECTIVE state, never what was asked for.
      if (result.detail) {
        toast.error(result.detail);
      } else {
        toast.success(`${result.insurer_code} ${result.line} is ${result.enabled ? 'ON' : 'OFF'} in ${result.environment}`);
      }
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  });
}

export function useLiveInsurers(line = 'motor') {
  return useQuery({
    queryKey: ['live-insurers', line],
    queryFn: () => insurerPluginsService.liveInsurers(line),
    staleTime: 60_000,
  });
}
